// src/features/messages/constants.js

// Same keys and order as MessageReactionType on the server
export const REACTIONS = [
  { key: 'thumbs_up', emoji: '👍' },
  { key: 'heart', emoji: '❤️' },
  { key: 'pray', emoji: '🙏' },
  { key: 'laugh', emoji: '😂' },
  { key: 'surprised', emoji: '😮' },
  { key: 'sad', emoji: '😢' },
];

export const REACTION_EMOJI = Object.fromEntries(REACTIONS.map(({ key, emoji }) => [key, emoji]));

export const MAX_CONTENT_LENGTH = 5000;

// Chip avatars default to dark grey initials, unreadable on a staff colour
export const AVATAR_CHIP_SX = { '& .MuiChip-avatar': { color: 'common.white', fontSize: '0.6rem', fontWeight: 600 } };
